import { ClaudeTemplate } from "../types";

/**
 * Compra directa a un medio (OTT de televisiones, OOH, prensa, radio offline, skins…).
 * No hay herramienta self-serve donde montar la campaña, así que el trabajo de Claude
 * es preparar la orden para el medio y comprobar las creatividades, sin enviar nada.
 */
export const directBuyTemplate: ClaudeTemplate = {
  id: "direct-buy",
  tool: "compra directa al medio",
  url: "no aplica: no hay plataforma self-serve; se gestiona con el medio por email o por su portal",
  hierarchy: "Medio / soporte → orden de inserción (IO) → piezas",
  idHint:
    "si el medio da un número de pedido o de campaña, ese es el ID; si no, dímelo y se vinculará a mano",
  steps: `
Esta línea se compra directamente al medio: **no hay campaña que crear en una plataforma**. Tu trabajo es dejar preparada la orden para el medio y comprobar el material. **No envíes ningún email ni formulario.**

### 1. Confirmar el contexto
1. Lee las notas de esta línea más abajo y dime qué medio y qué formato entiendes que son. Si no queda claro (por ejemplo, qué emisora, cabecera o circuito), para y pregunta.
2. Si el medio tiene un portal de anunciantes y ya lo tengo abierto en el navegador, dímelo y espera instrucciones antes de tocar nada.

### 2. Revisar las creatividades
1. Abre cada enlace del bloque "Creatividades" y comprueba que se puede acceder (sin permisos pendientes).
2. Haz una lista de las piezas: tipo (vídeo, cuña, imagen, arte final…), duración o medidas y nombre de archivo.
3. Si ves algo que puede no cumplir las especificaciones habituales del medio, dímelo (no lo modifiques).

### 3. Preparar la orden de inserción
Redacta un borrador de email o documento para el medio con:
- Asunto: Orden de inserción: {{names.order}}
- Anunciante: {{client}} · marca / producto: {{brand}}
- Campaña: {{names.campaign}}
- Formato / tipo: {{campaignType}} ({{format}})
- Fechas: {{goal.startDate}} → {{goal.endDate}}
- Ámbito: {{target.geography}} (país {{goal.country}})
- Volumen contratado: {{goal.volume}} con objetivo {{goal.kpi}}
- Coste neto unitario: {{goal.netUnitCost}} · inversión neta: {{goal.budget}}
- Público objetivo: {{target.gender}}, {{target.age}}
- Material: la lista del paso 2, con los enlaces
- Destino / tracking (si aplica): bloque "URLs de destino"
- Petición: confirmación de la reserva, número de pedido y, al terminar, el informe de entrega (impresiones, clics, visualizaciones, usuarios únicos) para cargarlo en BeApolo.
Deja el borrador en el chat para que lo revise. **No lo envíes.**
`,
};
